export const ACTIONS = {
  EDIT: "edit",
  ADD_EVIDENCE_AND_COMMENTS: "add evidence and comments",
  DELETE: "delete",
  DUPLICATE: "duplicate",
};

export const EDITOR_MODE = {
  ADD: "add",
  EDIT: "edit",
};

export const TAB_OPTIONS = [
  {
    count: 0,
    label: "Ongoing",
    value: "ONGOING",
  },
  {
    count: 0,
    label: "Completed",
    value: "COMPLETED",
  },
];

export const TAB_NAMES = {
  ONGOING: "ONGOING",
  COMPLETED: "COMPLETED",
};

export const DISPLAY_SEQUENCE = "displaySequence";
